import {
  SET_CART_QUANTITY,
  ADD_CART_ITEM,
  UPDATE_CART_ITEM,
  REMOVE_CART_ITEM,
  INIT_CART,
} from "./types";

export function setCartQuantity(carts) {
  let cartQuantity = 0
  if(carts) {
    cartQuantity = carts.reduce((accumulator, currentValue) => { return accumulator + currentValue.quantity }, 0)
  }

  return {
    type: SET_CART_QUANTITY,
    payload: cartQuantity,
  };
}

export function initCart(data = []) {   
  return {
    type: INIT_CART,
    payload: data,
  };
}

export function addCartItem(cart, carts = []) {
  let cartsAdd = carts
  let index = cartsAdd.findIndex((c => c.productId == cart.productId))
  if(index > -1) {
    cartsAdd[index].quantity += cart.quantity
  }
  else {
    cartsAdd.push(cart)
  }
    
  return {
    type: ADD_CART_ITEM,
    payload: cartsAdd,
  };
}

export function updateCartItem(cart, carts = []) {
  let cartsUpdate = carts
  let index = cartsUpdate.findIndex((c => c.productId == cart.productId))
  if(index > -1) {
    cartsUpdate[index].quantity = cart.quantity
  }
    
  return {
    type: UPDATE_CART_ITEM,
    payload: cartsUpdate,
  };
}

export async function removeCartItem(cart, carts = []) {
  let newCarts = await carts.filter((c => c.productId != cart.productId))
  console.log(newCarts)
  return {
    type: REMOVE_CART_ITEM,
    payload: newCarts,
  };
}



